import React from 'react';

const RetroButton = ({ children, variant = 'primary', className = '', ...props }) => {
  const baseStyle = "inline-flex items-center justify-center font-display uppercase tracking-widest text-lg md:text-xl px-8 py-4 border-4 border-retro-brown rounded-full shadow-retro transition-all active:shadow-retro-hover active:translate-y-[6px] active:translate-x-[6px]";
  
  const variants = {
    primary: "bg-retro-yellow text-retro-brown hover:bg-[#c9cd27]",
    secondary: "bg-retro-teal text-retro-brown hover:bg-[#259e9e]",
    dark: "bg-retro-brown text-retro-cream hover:bg-[#2c211d]",
    light: "bg-retro-cream text-retro-brown hover:bg-white"
  };

  return (
    <button 
      className={`${baseStyle} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default RetroButton;